import { render, staticRenderFns } from "./dialogFormPreview2.vue?vue&type=template&id=a1772516&scoped=true"
import script from "./dialogFormPreview2.vue?vue&type=script&lang=js"
export * from "./dialogFormPreview2.vue?vue&type=script&lang=js"
import style0 from "./dialogFormPreview2.vue?vue&type=style&index=0&id=a1772516&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1772516",
  null
  
)

export default component.exports